// extracted by mini-css-extract-plugin
export default {"main":"clean_main__-c5MC","section_1":"clean_section_1__OvHxW"};